
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({ name: 'PaginationBar' })
export default class PaginationBar extends Vue {
  @Prop({ required: true }) currentPage!: number;
  @Prop({ required: true }) lastPage!: number;
  @Prop({ required: true }) total!: number;
  @Prop({ required: true }) perPage!: number;
  @Prop({ default: () => [] }) rowsPerPageOptions!: number[];

  localPage: number = this.currentPage;
  perPageOpen: boolean = false;

  @Watch('currentPage')
  onCurrentPageChanged(val: number) {
    this.localPage = val;
  }

  get rangeStart(): number {
    return (this.currentPage - 1) * this.perPage + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.perPage, this.total);
  }

  get visiblePages(): (number | string)[] {
    const total = this.lastPage;
    const current = this.localPage;

    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const delta = 2;
    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);
    const pages: (number | string)[] = [1];

    if (left > 2) pages.push('...');
    for (let i = left; i <= right; i++) pages.push(i);
    if (right < total - 1) pages.push('...');

    pages.push(total);
    return pages;
  }

  closePerPage() {
    this.perPageOpen = false;
  }

  selectPerPage(opt: number) {
    this.perPageOpen = false;
    this.$emit('per-page-change', opt);
  }

  changePage(page: number) {
    if (page < 1 || page > this.lastPage || page === this.localPage) return;
    this.localPage = page;
    this.$emit('page-change', page);
  }
}
